module.exports = __webpack_public_path__ + "files/34d3af5394c6164880820e7c26938a8b.png";